import type { ScaleValues } from './types';

// For macOS browsers, we have no way to determine the scrollbar width, so we assume 18 pixels here.
export const SCROLLBAR_WIDTH = 18;

export const TRANSITION_DURATION = 200;

export const TOOLBAR_HEIGHT = 70;
export const TOOLBAR_TRANSITION_DURATION = TRANSITION_DURATION / 2;

export const SCALE_FACTOR = 4 / 3;
export const MAX_SCALE_FACTOR = SCALE_FACTOR ** 5;

export const CONTENT_MARGIN_DESKTOP = 30;
export const CONTENT_MARGIN_MOBILE = 10;

export const DEFAULT_SCALE: ScaleValues = {
  current: 1,
  min: 1,
  max: MAX_SCALE_FACTOR,
};

export const MAX_FILE_SIZE_BYTES = 50 * 1000 * 1000; // 50 MB

export const SUPPORTED_FILE_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp'];
